/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { Modal, Input } from 'antd-v5';
import { postRequest } from '../../../../../../core/apiRequests';
import { notificationError, notificationSuccess } from '../../../../../../core/actions';

const EditActivityModal = props => {
  const [notes, setNotes] = useState(props.notes || '');

  const saveActivityHandler = () => {
    const reqObj = {
      params: ['clients', 'updateClientActivity'],
      data: {
        id: props.id,
        client_id: props.clientId,
        notes,
      },
    };

    (async () => {
      const respData = await postRequest(reqObj);
      if (respData) {
        notificationSuccess('Activity Saved!');
        props.onSuccess({ id: props.id, notes });
        props.toggleEditModal(false);
      } else {
        notificationError('Failed To Save Activity');
      }
    })();
  };

  return (
    <Modal
      title="Edit Notes"
      open
      onCancel={() => props.toggleEditModal(false)}
      onOk={saveActivityHandler}
      okText="Save"
      destroyOnClose
      width={404}
      centered
    >
      <Input.TextArea
        rows={7}
        placeholder="Add notes..."
        value={notes}
        onChange={e => setNotes(e.target.value)}
      />
    </Modal>
  );
};

export default EditActivityModal;
